<template>
  <div>
    <el-dialog :modal="false" fullscreen append-to-body :visible.sync="show">
      <div>
        <h2>出访报告</h2>
        <el-card>
          <div>
            <el-form ref="dialogForm" :model="addForm" :rules="rules" label-width="140px" label-position="right">
              <el-row>
                <el-col>
                  <el-form-item label="出访报告标题：" prop="reportTitle">
                    <el-input maxlength="100" v-model="addForm.reportTitle" placeholder="请输入出访报告标题"
                      clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="出访报告内容：" prop="reportContent">
                    <div class="text-hidden">
                      <sj-editor ref="editor" v-model="addForm.reportContent" :defaultFont="true"
                        :maxlength="500" :show-word-limit="true"></sj-editor>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item label="附件：" prop="reportFile">
                    <template #label>
                      <span>附件</span>
                    </template>
                    <span style="cursor: pointer;" class="file-name" v-show="addForm.reportFile.fileName != ''" @click="
                      handlePreviewFile(
                        addForm.reportFile.path,
                        addForm.reportFile.fileName
                      )
                      ">{{ addForm.reportFile.fileName }}</span>

                    <img-file style="display:inline-block;margin:0 5px" v-model="addForm.reportFile" :limit="50"
                      accept=".jpg,.jpeg,.png,.gif,.pdf,.PDF" :text="addForm.reportFile.path ? '重新上传' : '上传'"
                      @success="handleFileUploadSuccess"></img-file>

                    <span style="color: #409EFF;cursor: pointer;" @click="handleDeleteFile(addForm.reportFile)"
                      v-show="addForm.reportFile.path">删除</span>
                    <span style="padding-left: 8px; color: red;">请上传签字盖章版本出访报告</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-card>
        <el-card>
          <div slot="header">出访成果情况</div>
          <div>
            <el-form ref="dialogBtmForm" :model="addForm" :rules="btmRules" label-width="140px">
              <el-col>
                <el-form-item label="出访任务：" class="row_item whole-line" prop="visitTask">
                  <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" maxlength="300" show-word-limit
                    v-model="addForm.visitTask" placeholder="请输入出访任务"></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="合同签约：" prop="signFlag">
                  <el-radio label="0" v-model="addForm.signFlag">是</el-radio>
                  <el-radio label="1" v-model="addForm.signFlag">否</el-radio>
                </el-form-item>
              </el-col>
              <el-col>
                <el-table v-if="signTableVisible" :data="signTableData" border style="width: 100%">
                  <el-table-column prop="ownerUnitName" label="业主单位名称">
                    <template slot-scope="props">
                      <el-input v-model="props.row.ownerUnitName"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="projectName" label="项目名称">
                    <template slot-scope="props">
                      <el-input v-model="props.row.projectName"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="goalAmount">
                    <template slot="header" slot-scope="scope">
                      合同金额（万元）
                      <el-tooltip class="item" effect="dark" content="根据签署日期汇率折算为人民币" placement="top-start">
                        <i class="el-icon-warning-outline"></i>
                      </el-tooltip>
                    </template>
                    <template slot-scope="props">
                      <el-input v-model="props.row.goalAmount" type="number"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="remark" label="备注">
                    <template slot-scope="props">
                      <el-input v-model="props.row.remark"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="120">
                    <template #default="scope">
                      <!-- <el-button type="text" @click="editRow(scope.row, 1)">编辑</el-button> -->
                      <el-button type="text" @click="delRow(scope.$index, 1)" :disabled="signTableData.length <= 1"
                        danger>删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-button class="add-row" v-if="signTableVisible" @click="addRow(1)">+增加行</el-button>
              </el-col>

              <el-col>
                <el-form-item label="项目中标：" prop="targetFlag">
                  <el-radio label="0" v-model="addForm.targetFlag">是</el-radio>
                  <el-radio label="1" v-model="addForm.targetFlag">否</el-radio>
                </el-form-item>
              </el-col>
              <el-col v-if="chapterTableVisible">
                <el-table :data="chapterTableData" border style="width: 100%">
                  <el-table-column prop="ownerUnitName" label="业主单位名称">
                    <template slot-scope="props">
                      <el-input v-model="props.row.ownerUnitName"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="projectName" label="项目名称">
                    <template slot-scope="props">
                      <el-input v-model="props.row.projectName"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="goalAmount">
                    <template slot="header" slot-scope="scope">
                      中标金额（万元）
                      <el-tooltip class="item" effect="dark" content="根据签署日期汇率折算为人民币" placement="top-start">
                        <i class="el-icon-warning-outline"></i>
                      </el-tooltip>
                    </template>
                    <template slot-scope="props">
                      <el-input v-model="props.row.goalAmount" type="number"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="remark" label="备注">
                    <template slot-scope="props">
                      <el-input v-model="props.row.remark"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="120">
                    <template #default="scope">
                      <!-- <el-button type="text" @click="editRow(scope.row, 2)">编辑</el-button> -->
                      <el-button type="text" :disabled="chapterTableData.length <= 1" @click="delRow(scope.$index, 2)"
                        danger>删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-button class="add-row" @click="addRow(2)">+增加行</el-button>
              </el-col>

              <el-col>
                <el-form-item label="其他成果：" class="row_item whole-line" prop="otherResult">
                  <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" maxlength="300" show-word-limit
                    v-model="addForm.otherResult" placeholder="请输入其他成果"></el-input>
                </el-form-item>
              </el-col>
              <span class="remark">如：签署合作或框架性协议。</span>
              <el-col>
                <el-form-item label="下一步计划：" class="row_item whole-line" prop="nextPlan">
                  <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" maxlength="300" show-word-limit
                    v-model="addForm.nextPlan" placeholder="请输入下一步计划"></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item class="row_item whole-line">
                  <template slot='label'>
                    <span v-html="'需要集团&nbsp;&nbsp;&nbsp;<br/>解决的事项：'"></span>
                  </template>
                  <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" maxlength="300" show-word-limit
                    v-model="addForm.requireSolve" placeholder="请输入需要集团解决的事项"></el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </div>
        </el-card>
        <div class="footer">
          <!-- <span slot="footer" class="dialog-footer"> -->
          <el-button type="primary" @click="save">保存</el-button>
          <el-button @click="close">取消</el-button>
          <!-- </span> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LetterManagement from "@/api/foreign/foreign_licence_manage/LetterManagement.js";
import logs from "../foreign_abroad_exchange/components/operate_logs";
import { mapGetters } from "vuex";
const Api = new LetterManagement();
import imgFile from "../../components/img-file";
import ItemApi from "@/api/setup";

export default {
  name: "VisitReportEdit",
  data() {
    const validateReportFile = (rule, value, callback) => {
      // 检查path是否存在
      if (!value || !value.path || value.path.trim() === "") {
        callback(new Error("请上传附件"));
      } else {
        callback();
      }
    };
    return {
      // reportFile: { path: "", fileName: "" },
      addForm: {
        missiveId: "", //公函id
        reportTitle: "", // 标题
        reportContent: "", //出访报告内容
        reportFile: { path: "", fileName: "" },

        task: "", // 任务
        signFlag: "", //合同签约
        targetFlag: "", // 项目中标
        otherResult: "" // 其他成果
      },
      show: false,
      signTableVisible: false,
      signTableData: [
        {
          ownerUnitName: "",
          projectName: "",
          goalAmount: "",
          remark: "",
          goalType: 0
        }
      ], // 合同签约表格数据
      chapterTableVisible: false,
      chapterTableData: [
        {
          ownerUnitName: "",
          projectName: "",
          goalAmount: "",
          remark: "",
          goalType: 1
        }
      ], // 项目中标表格数据

      cloneDom: null,
      textDom: null,
      textQueryDom: null,
      hiddenForm: {
        reportContent: ""
      },
      // TODO 团组中有党委书记、党支部书记、董事长、执行董事、党委副书记、总经理、纪委书记、纪委副书记、副总经理、总会计师职务的需要出访报告必填校验
      rules: {
        reportTitle: [
          { required: true, message: "请输入出访报告标题", trigger: "change" }
        ],
        reportContent: [
          { required: true, message: "请输入出访报告内容", trigger: "change" }
        ],
        // 附件
        reportFile: [
          // 附件校验规则
          {
            required: true,
            validator: validateReportFile,
            trigger: "change, blur"
          }
        ]
      },
      btmRules: {
        visitTask: [
          { required: true, message: "请输入出访任务", trigger: "blur" }
        ],
        targetFlag: [
          { required: true, message: "请选择项目中标", trigger: "change" }
        ],
        signFlag: [
          { required: true, message: "请选择合同签约", trigger: "change" }
        ],
        nextPlan: [
          { required: true, message: "请输入下一步计划", trigger: "blur" }
        ],
        otherResult: []
      },

      storageKey: '',
      visitId: '',
      travelStatus: null,
      visitRportList: [],//出访报告
    };
  },
  components: {
    logs,
    imgFile
  },
  computed: {
    ...mapGetters(["token"]),
    // btmRules() {
    //   const isOtherResultRequired = this.addForm.signFlag === "1" && this.addForm.targetFlag === "1";
    //   return {
    //     visitTask: [
    //       { required: true, message: "请输入出访任务", trigger: "blur" }
    //     ],
    //     targetFlag: [
    //       { required: true, message: "请选择项目中标", trigger: "change" }
    //     ],
    //     signFlag: [
    //       { required: true, message: "请选择合同签约", trigger: "change" }
    //     ],
    //     nextPlan: [
    //       { required: true, message: "请输入下一步计划", trigger: "blur" }
    //     ],
    //     otherResult: isOtherResultRequired ? [
    //       { required: true, message: "请输入其他成果", trigger: ["blur", "change"] }
    //     ] : []
    //   };
    // }
  },
  watch: {
    "addForm.reportContent": {
      handler(newV) {
        console.log({ newV });

        this.$refs.dialogForm &&
          this.$refs.dialogForm.validateField("reportContent");
        if (newV) {
          setTimeout(() => {
            this.textDom = document.querySelector(".text-hidden");
            this.cloneDom = this.textDom.cloneNode(true);
            this.textQueryDom = this.cloneDom.querySelectorAll("p font");
          }, 100);
        }
      },
      immediate: true
    },
    "addForm.reportFile": {
      handler(newVal) {
        this.$nextTick(() => {
          this.$refs.dialogForm.validateField("reportFile");
        });
      },
      deep: true // 深度监听对象内部变化
    },
    "addForm.signFlag"(val) {
      this.signTableVisible = val === "0";
      this.updateOtherResultRule();
    },
    "addForm.targetFlag"(val) {
      this.chapterTableVisible = val === "0";
      this.updateOtherResultRule();
    }
  },
  methods: {
    updateOtherResultRule() {
      if (this.addForm.signFlag === "1" && this.addForm.targetFlag === "1") {
        this.btmRules.otherResult = [
          { required: true, message: "请输入其他成果", trigger: ["blur"] }
        ];
      } else {
        this.btmRules.otherResult = [];
        this.$nextTick(() => {
          this.$refs.dialogBtmForm && this.$refs.dialogBtmForm.clearValidate("otherResult");
        });
      }
    },
    getList() {
      let itemApi = new ItemApi();
      let param = {
        itemInfoId: this.visitId
      };
      itemApi.getVisitReportByItemInfoId(param).then(v => {
        if (v.data && v.data.length > 0) {
          // 获取最后一条数据作为表单数据
          const reportData = v.data[v.data.length - 1];

          // 处理报告文件
          const reportFile = {
            path: reportData.visitReportPath,
            fileName: reportData.visitReportPath ? reportData.visitReportPath.split("_")[1] : ""
          };

          // 处理 visitGoals 数据
          const signData = [];
          const targetData = [];
          if (reportData.visitGoals && reportData.visitGoals.length) {
            reportData.visitGoals.forEach(item => {
              if (item.goalType == 0) {
                signData.push(item);
              } else {
                targetData.push(item);
              }
            });
          }

          // 更新表单数据
          this.addForm = {
            ...this.addForm,
            missiveId: reportData.missiveId || "",
            reportTitle: reportData.reportTitle || "",
            reportContent: reportData.reportContent || "",
            reportFile: reportFile,
            visitTask: reportData.visitTask || "",
            signFlag: reportData.signFlag !== undefined ? reportData.signFlag.toString() : "",
            targetFlag: reportData.targetFlag !== undefined ? reportData.targetFlag.toString() : "",
            otherResult: reportData.otherResult || "",
            nextPlan: reportData.nextPlan || "",
            requireSolve: reportData.requireSolve || ""
          };

          // 更新表格数据
          this.signTableData = signData.length > 0 ? signData : [{ ownerUnitName: "", projectName: "", goalAmount: "", remark: "", goalType: 0 }];
          this.chapterTableData = targetData.length > 0 ? targetData : [{ ownerUnitName: "", projectName: "", goalAmount: "", remark: "", goalType: 1 }];

          // 设置富文本编辑器内容
          this.$nextTick(() => {
            if (this.$refs.editor) {
              this.$refs.editor.setContent(this.addForm.reportContent);
            }
          });
        }
      });

      // // 保留原有的 listVisitInfo 调用
      // itemApi.listVisitInfo({ itemInfoId: this.visitId + "_B" }).then(res => {
      //   if (res.data.length) {
      //     this.firstRowData = res.data[0];
      //     this.list = res.data.map(item => {
      //       return {
      //         ...item,
      //         travelFiles: item.travelFiles || []
      //       };
      //     });
      //   } else {
      //     this.list = [];
      //   }
      // });
    },
    init() {
      this.show = true;
      // const obj = JSON.parse(sessionStorage.getItem("VISIT_REPORT")) || {
      // 跳转新页面 从 localStorage 获取数据，使用从 URL 传入的 storageKey
      const obj = JSON.parse(localStorage.getItem(this.storageKey)) || {
        missiveId: "", //公函id
        reportTitle: "", // 标题
        reportContent: "", //出访报告内容
        reportFile: { path: "", fileName: "" },

        task: "", // 任务
        signFlag: "", //合同签约
        targetFlag: "", // 项目中标
        otherResult: "", // 其他成果
        visitGoals: [
          {
            ownerUnitName: "",
            projectName: "",
            goalAmount: "",
            remark: "",
            goalType: 0
          },
          {
            ownerUnitName: "",
            projectName: "",
            goalAmount: "",
            remark: "",
            goalType: 1
          }
        ]
      };
      this.signTableData = [];
      this.chapterTableData = [];
      obj.visitGoals.forEach(item => {
        if (item.goalType == 0) {
          this.signTableData.push(item);
        } else {
          this.chapterTableData.push(item);
        }
      });
      delete obj.signTableData;
      delete obj.chapterTableData;
      this.$nextTick(() => {
        this.$refs.editor.setContent(obj.reportContent);
      });
      this.addForm = { ...obj };
    },
    handleFileUploadSuccess() {
      // 等待DOM更新后校验
      this.$nextTick(() => {
        this.$refs.dialogForm.validateField("reportFile");
      });
    },
    // 删除
    handleDeleteFile() {
      this.addForm.reportFile = { path: "", fileName: "" };
      this.$nextTick(() => {
        this.$refs.dialogForm.validateField("reportFile");
      });
    },
    // 文件预览
    handlePreviewFile(filePath, fileName) {
      let src = `/share-foreign/commannex/viewAnnex?path=${filePath}&token=${this.token}`;
      if (fileName.match(/\.pdf$/) || fileName.match(/\.PDF$/)) {
        window.open(src);
      } else {
        this.$message("仅支持pdf类型文件的预览");
      }
    },
    addRow(type) {
      if (type === 1) {
        if (this.signTableData.length >= 10) {
          return this.$message.warning("已达到当前行数上限！");
        }
        this.signTableData.push({
          ownerUnitName: "",
          projectName: "",
          goalAmount: "",
          remark: ""
        });
      } else {
        if (this.chapterTableData.length >= 10) {
          return this.$message.warning("已达到当前行数上限！");
        }
        this.chapterTableData.push({
          ownerUnitName: "",
          projectName: "",
          goalAmount: "",
          remark: ""
        });
      }
    },

    delRow(index, type) {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          if (type === 1) {
            this.signTableData.splice(index, 1);
          } else {
            this.chapterTableData.splice(index, 1);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    updateSize() {
      if (this.textQueryDom) {
        for (let i = 0; i < this.textQueryDom.length; i++) {
          let size = this.textQueryDom[i].getAttribute("size");
          switch (size) {
            case "1":
              this.textQueryDom[i].setAttribute("style", "font-size:34.7px");
              break;
            case "2":
              this.textQueryDom[i].setAttribute("style", "font-size:29.3px");
              break;
            case "3":
              this.textQueryDom[i].setAttribute("style", "font-size:21.3px");
              break;
            case "4":
              this.textQueryDom[i].setAttribute("style", "font-size:20px");
              break;
            case "5":
              this.textQueryDom[i].setAttribute("style", "font-size:18.7px");
              break;
            case "6":
              this.textQueryDom[i].setAttribute("style", "font-size:14px");
              break;
          }
        }
        let dom = this.cloneDom.querySelectorAll(".w-e-text")[0];
        this.hiddenForm.reportContent = dom.innerHTML;
      }
    },
    goBack() {
      // // 弹框展示调方法
      // this.$emit("change");
      // this.show = false;

      // 跳转新页面调方法
      window.close();
    },
    close() {
      // // 清除表单数据
      // this.addForm = {
      //   missiveId: "",
      //   reportTitle: "",
      //   reportContent: "",
      //   reportFile: { path: "", fileName: "" },
      //   visitTask: "",
      //   signFlag: "",
      //   targetFlag: "",
      //   otherResult: "",
      //   nextPlan: "",
      //   requireSolve: ""
      // };

      // // 重置表格数据
      // this.signTableData = [{ ownerUnitName: "", projectName: "", goalAmount: "", remark: "", goalType: 0 }];
      // this.chapterTableData = [{ ownerUnitName: "", projectName: "", goalAmount: "", remark: "", goalType: 1 }];

      // // 清除其他数据
      // this.visitRportList = [];
      // this.list = [];
      // this.firstRowData = {};

      this.goBack();
    },
    setForm() {
      let obj = {
        ...this.addForm
        // reportFile: this.reportFile.path // 将附件路径添加到表单数据中
      };
      return obj;
    },
    // 保存
    save(text) {
      this.updateSize();
      let obj = this.setForm();
      // 校验必填 如果为否则不校验表格 是则表格内容必填都填完
      const signflag = this.signTableData.find(item => {
        return !item.ownerUnitName || !item.projectName || !item.goalAmount;
      });
      if (signflag && this.addForm.signFlag == 0) {
        return this.$message.warning("请完善合同签约内容");
      }
      const chapterflag = this.chapterTableData.find(item => {
        return !item.ownerUnitName || !item.projectName || !item.goalAmount;
      });
      if (this.addForm.targetFlag == 0 && chapterflag) {
        return this.$message.warning("请完善项目中标内容");
      }
      this.$refs.dialogForm.validate(valid1 => {
        if (valid1) {
          this.$refs.dialogBtmForm.validate(valid2 => {
            if (valid2) {
              const a = this.signTableData.map(item => {
                item.goalType = "0";
                return item;
              });
              const b = this.chapterTableData.map(item => {
                item.goalType = "1";
                return item;
              });
              obj.visitGoals = [...a, ...b];
              // sessionStorage.setItem("VISIT_REPORT", JSON.stringify(obj));
              // 使用从 URL 获取的 storageKey 保存数据
              localStorage.setItem(this.storageKey, JSON.stringify(obj));
              this.goBack();
            }
          });
        }
      });
    }
  },
  mounted() {
    // 跳转新页面方式调接口 从 URL 参数获取 storageKey
    this.storageKey = this.$route.query.storageKey
    this.travelStatus = this.$route.query.travelStatus
    this.init();
    const localData = JSON.parse(localStorage.getItem(this.storageKey)) || {};
    if (this.travelStatus !== 2 && Object.keys(localData).length === 0) {//被退回且本地数据不存在，回显上一次数据
      this.visitId = this.storageKey.replace("VISIT_REPORT_", "")
      this.getList()
    }
  }
};
</script>
<style lang="scss" scoped>
.text-hidden {
  ::v-deep p {
    text-indent: 2rem;
  }
}
h2 {
  text-align: center;
}
::v-deep .el-card {
  border: none;
}
::v-deep .el-card__header {
  padding: 0;
  border: none;
}

.el-card__header div {
  line-height: 35px;
  border-bottom: 2px solid #818181;
}
// 为附件校验错误添加样式
::v-deep .el-form-item__error {
  margin-left: 140px;
}
::v-deep .el-form-item__content {
  z-index: 1;
}

.remark {
  margin-left: 146px;
  position: relative;
  top: -10px;
  font-size: 14px;
}
.add-row {
  position: relative;
  top: -19px;
  width: 100%;
}
.footer {
  margin: 0 auto;
  width: 100%;
  text-align: center;
}
</style>
<style>
.is-fullscreen.el-dialog {
  max-height: calc(100%);
  max-width: calc(100%);
}
</style>
